import { render, staticRenderFns } from "./resultBody.vue?vue&type=template&id=3355b7e0&scoped=true&"
import script from "./resultBody.vue?vue&type=script&lang=js&"
export * from "./resultBody.vue?vue&type=script&lang=js&"
import style0 from "./resultBody.vue?vue&type=style&index=0&id=3355b7e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3355b7e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCol,VRow,VSnackbar})
